module.exports = __webpack_public_path__ + "img/losaprily-images-grid.33c7ea9a.png";